var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{class:_vm.$vuetify.breakpoint.mobile ? 'pt-10' : 'mx-0 mt-0 mb-n10 welcome-background',attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('h1',{class:['welcome-title', {'inverted--text': !_vm.$vuetify.breakpoint.mobile}]},[_vm._v(" "+_vm._s(_vm.$t("startPageStrings.pageHeader"))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }